export default __webpack_public_path__ + "static/media/international-humanitarian-city.44d0a6de.png";